<section class="row row-20">
  <section class="container-pdp vaxelis_restrict" *ngIf="productUnavailableForEmployee">
    You are not eligible to view the product
  </section>
  <section class="container-pdp" *ngIf="productDetails && !productUnavailableForEmployee">
    <aside aria-label="Product Details" class="col-xs-12 col-sm-4 col-md-4 right-navigation float-right">
      <div *ngIf="
          isVariantSelected && isFormularyCustomer && productDetails?.formularyProduct">
        <span class="formulary-text">MY&nbsp;FORMULARY</span>
      </div>
      <div *ngIf="
          isVariantSelected &&
          !isFormularyCustomer
        ">
        <span class="nonformulary-text"></span>
      </div>
      <a *ngIf="
          productDetails?.images != undefined ||
          productDetails?.images?.length > 0
        " (click)="openImage(content)">
        <cx-media class="cx-product-image mt-0" style="width: 289px; height: 198px; margin-left: 7px"
          [container]="productDetails?.images?.PRIMARY" format="product" [alt]="productDetails?.summary">
        </cx-media>
      </a>
      <a *ngIf="
          productDetails?.images === undefined ||
          productDetails?.images?.length === 0
        ">
        <img class="image-set-in-card product-img"
          [src]="'../../assets/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" alt="" />
      </a>
      <span class="fullscreen-image selected align-bottom" data-toggle="modal" data-target="#pdp-image-zoom">
        <a (click)="openImage(content)" title="fullscreen link"><img class="expandable"
            src="../../../assets/icons/fullscreen.svg" alt="" /></a>
      </span>
      <a>
        <div *ngFor="let carousel of gallery">
          <div class="xzoom-thumbs leftFloat">
            <a class="item">
              <cx-media class="cx-product-image carousel-zoom maxHeight" [container]="carousel?.product"
                format="product" [alt]="img">
              </cx-media>
            </a>
          </div>
        </div>
      </a>
      <br /><br />

      <ng-template #content let-modal>
        <ngb-carousel *ngIf="
            productDetails?.images != undefined ||
            productDetails?.images?.length > 0
          " ngClass="productDetails?.images?.GALLERY.length > 0 ? 'carousel-nopagination' : 'carousel-pagination' ">
          <ng-template ngbSlide *ngFor="let carousel of gallery">
            <div class="headerstrip">
              <div class="closeBtn">
                <a (click)="closePopup()"><img [src]="'../../../assets/icons/'+baseSiteId+'/close.svg'"
                    width="20px" /></a>
              </div>
            </div>

            <div class="picsum-img-wrapper">
              <cx-media class="cx-product-image carousel-pdp" [container]="carousel?.product" format="product"
                [alt]="img">
              </cx-media>
              <div class="xzoom-thumbs">
                <a class="item">
                  <cx-media class="cx-product-image carousel-zoom" [container]="carousel?.product" format="product"
                    [alt]="img">
                  </cx-media>
                </a>
              </div>
            </div>
          </ng-template>
        </ngb-carousel>
      </ng-template>
      <aside aria-label="Product Details Pdf " class="right-navigation resources-section" *ngIf="monograph?.length>0"
        [ngClass]="{
          'mt-5':
            productDetails?.images != undefined ||
            productDetails?.images?.length > 0
        }">
        <section *ngIf="loggedInDevice == 'others'">
          <p class="pdfs-title">
            DOCUMENTS
          </p>
          <section class="prod-detail-pdfs" *ngFor="let doc of monograph">
            <p class="pdfs-list">
              <img class="pdf-icon" [src]="'../../assets/icons/'+baseSiteId+'/pdf.svg'" alt=" " />
              <a alt="link" (click)="openInNewTab(doc.url)" target=" _blank " class="file-link blue">{{
                doc?.realFileName }}</a>
            </p>
          </section>
        </section>
      </aside>
      <div class="ml-2"></div>
      <!-- <div class="ml-2" *ngIf="banner?.url && loggedInDevice == 'others'">
        <a [href]="banner?.redirection" target="_self">
          <img class="image-set-in-card banner-img" [src]="banner?.url" alt="banner-img" />
        </a>
      </div> -->
    </aside>

    <section class="col-xs-12 col-sm-8 col-md-8 left-section pb-2 float-left">
      <h3 class="pdp-title" [innerHTML]="baseProductName"></h3>
      <p class="desc-class" [innerHTML]="baseProductDescription"></p>
      <div *ngIf="productDetails?.variantOptions?.length == 1">
        <p class="custom-tab-p singlevariantinfo-desc" [innerHTML]="productDetails.variantOptions[0].description">
        </p>
        <p class="selectedVariant--fluSeason" *ngIf="productDetails.variantOptions[0].flu && 
        productDetails.variantOptions[0].fluCategories?.length">
          {{productDetails.variantOptions[0].fluCategories[0] }} Formula<span
            *ngIf="productDetails.variantOptions[0].shipNow?.toLowerCase() == 'on'"><span
              [ngStyle]="{ color: '#333' }">-&nbsp;</span>Available
            to order now</span>
        </p>
      </div>
      <div class="variants-selection d-flex flex-column align-items-start"
        *ngIf="productDetails.variantOptions?.length > 1">

        <ng-select placeholder="select presentation" (change)="populatePDP($event.code, true)"
          [items]="productDetails.variantOptions" class="pdp-dropdown float-left" [(ngModel)]="selectedVariant"
          bindLabel="description" [multiple]="false">
          <ng-template ng-option-tmp let-item="item">
            <h4 class="variants-dropdown--variant-description">
              <span [innerHTML]="item.description"></span><br />
              {{ item.code }}
            </h4>
            <p class="variants-dropdown--flu-season" *ngIf="item?.flu && item?.fluCategories?.length">
              {{ item?.fluCategories[0] }} Formula
              <span *ngIf="item?.shipNow?.toLowerCase() == 'on'"><span
                  [ngStyle]="{ color: '#333' }">-&nbsp;</span>Available to
                order now</span>
            </p>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <h4 class="variants-dropdown--label">
              <span [innerHTML]="selectedVariant?.description"></span><br />
              {{ selectedVariant?.code }}
            </h4>
          </ng-template>
        </ng-select>

        <div class="selectedVariant mt-2" *ngIf="isVariantSelected">
          <p class="selectedVariant--desc" [innerHTML]="productDetails?.description"></p>
          <p class="selectedVariant--fluSeason" *ngIf="isVariantSelected && productDetails.flu && fluSeason">
            {{ fluSeason }} Formula<span *ngIf="productDetails?.shipNow?.toLowerCase() == 'on'"><span
                [ngStyle]="{ color: '#333' }">-&nbsp;</span>Available to
              order now</span>
          </p>
        </div>
      </div>
      <p class="ndcCode">{{ productDetails?.ndcCode }}</p>
      <div [ngStyle]="{ 'font-size.px': '16' }">
        <span class="prod-code" *ngIf="isVariantSelected">{{ productDetails.code }}&nbsp;|</span>{{
        productDetails.manufacturer }}
      </div>

      <div class="contractGroupBlock" *ngIf="
         userDetails && 
         isVariantSelected && 
         (isFormularyCustomer ? productDetails?.formularyProduct : true) && 
         (productDetails?.yellowFever ? isYFauthorized : true) &&
         productDetails.priceInfos?.conditions?.length 
        ">
        <h4>Contract Group</h4>
        <h5 *ngIf="productDetails.priceInfos?.conditions?.length == 1" [ngStyle]="{ 'font-size.px': '14' }">
          {{ productDetails.priceInfos.conditions[0].contractDesc }}
        </h5>
        <ng-select placeholder="Select Contract Group" (change)="selectedContractGroup = $event"
          *ngIf="productDetails.priceInfos?.conditions.length > 1" [items]="productDetails.priceInfos.conditions"
          [(ngModel)]="selectedContractGroup" bindLabel="contractDesc" [multiple]="false">
        </ng-select>
      </div>
      <section class="batch-info">
        <!-- <p class="desc-title" *ngIf="productDetails?.batchInfo?.batchNumber">{{'plp.batchNumber'|cxTranslate}}
                    <span class="desc-details">{{productDetails?.batchInfo?.batchNumber}}</span>
                </p>
                <p class="desc-title" *ngIf="productDetails?.batchInfo?.batchNumber">{{'plp.expiryDate'|cxTranslate}} :
                    <span class="desc-details">{{productDetails?.batchInfo?.expiryDate}}</span>
                </p>
                <p *ngIf="productDetails?.batchInfo?.batchNumber">{{'plp.batchInfo'|cxTranslate}}</p>
                <p class="desc-title">{{'plp.productNumber'|cxTranslate}} : <span
                        class="desc-details">{{productDetails?.code}}</span> </p> -->
        <hr class="line" />
        <section class="d-flex flex-column" aria-description="Section which holds price, units and action button">
          <div class="row w-100 mt-3 pl-3" [ngClass]="{'reserve-flex':buttonName==='Reserve'}">
            <div class="price-details" *ngIf="userDetails &&
               isVariantSelected && 
               (isFormularyCustomer ? productDetails.formularyProduct : true) &&
               (productDetails?.yellowFever ? isYFauthorized : true)" [ngClass]="
                productDetails.flu &&
                productDetails.shipNow.toLowerCase() == 'off'
                  ? 'col-sm-8'
                  : 'col-sm-6'
              " [ngClass]="{'assitancee': isLocationSelected &&
              productDetails.flu &&
              productDetails.shipNow.toLowerCase() == 'off' &&
              prodAvailableForOrder(productDetails)}">
              <ng-container *ngIf="
                    isLocationSelected &&
                    productDetails.flu &&
                    productDetails.shipNow.toLowerCase() == 'off' &&
                    prodAvailableForOrder(productDetails);
                  else price
                ">
                <h3 class="reserve-note">
                  For assistance with your reservation, call
                  <span class="purpleColor" *ngIf="baseSiteId == 'vsh'">1-800-VACCINE (1-800-822-2463)</span>
                  <span class="purpleColor" *ngIf="baseSiteId == 'vax'">1-800-752-9338</span>
                  or contact your Sanofi Pasteur vaccine specialist.
                </h3>
              </ng-container>
              <ng-template #price>
                <div class="d-flex flex-column" *ngIf="prodAvailableForOrder(productDetails)">
                  <h4 [ngStyle]="{ color: '#313131', 'font-size.px': '14' }">
                    {{ "plp.yourPrice" | cxTranslate }}
                  </h4>
                  <span class="prod-price">
                    {{ productDetails.isPriceAvailable ? getPrice() : "$--" }}
                  </span>
                  <p *ngIf="productDetails?.priceInfos?.fexciseTax">
                    {{ productDetails.priceInfos?.fexciseTax.value ?
                    productDetails.priceInfos?.fexciseTax.formattedValue :
                    '$--'
                    }}/package Federal Excise Tax will be added
                  </p>
                </div>
              </ng-template>
            </div>
            <!-- unit selector  -->
            <div class="col unit-details p-0">
              <div class="row no-gutters">
                <div class="col-sm-6 d-flex flex-column align-items-center" *ngIf="
                    userDetails &&
                    isLocationSelected &&
                    isVariantSelected &&
                    (productDetails?.flu ? productDetails.shipNow?.toLowerCase() == 'on' : true)
                    && prodAvailableForOrder(productDetails) &&
                    (isFormularyCustomer ? productDetails.formularyProduct : true) &&
                    (productDetails?.yellowFever ? isYFauthorized : true)
                  ">
                  <b class="prodUnits">{{ "plp.units" | cxTranslate }}</b>
                  <div class="d-flex flex-row justify-content-center unit-selector">
                    <img [src]="'../../assets/icons/'+baseSiteId+'/less_new.svg'" aria-hidden="true"
                      id="{{ 'unitMinus' + productDetails?.code }}" alt="minus_icon" (click)="
                        performQuantityComputation(2, productDetails?.code);
                        showLimitPopoverValueFor !== productDetails?.code &&
                          p.close()
                      " />

                    <ng-template #popContent>
                      <img src="../../../assets/icons/{{baseSiteId}}/warning_red_new.png" alt="warning_icon" />
                      <span>Quantity limit is '{{ productIsLimitedTo }}'
                        Units</span>
                    </ng-template>

                    <input type="number" #number class="prod-quantity text-center"
                      [value]="productIsLimitedTo == '0' ? '0' : '1'" [ngbPopover]="popContent" placement="top"
                      triggers="manual" #p="ngbPopover" [autoClose]="false" popoverClass="custom-restriction-popover"
                      (keyup)="
                        performQuantityComputation(null, productDetails?.code);
                        showLimitPopoverValueFor == productDetails?.code
                          ? p.open()
                          : p.close()
                      " id="{{ 'prodQuantity' + productDetails?.code }}" appNoMouseScroll min="0" />

                    <img [src]="'../../assets/icons/'+baseSiteId+'/more.svg'" aria-hidden="true" (click)="
                        performQuantityComputation(1, productDetails?.code);
                        showLimitPopoverValueFor == productDetails?.code &&
                          p.open()
                      " id="{{ 'unitPlus' + productDetails?.code }}" alt="plus_icon" />
                  </div>
                  <div class="doses-section" id="{{ 'noOfDoses' + productDetails?.code }}">
                    <!-- {{ productDetails.quantityPerUnit }}
                    {{ productDetails.uom }} -->
                  </div>
                </div>
                <!--if GovtCustomer and isGovtLocationSelected:
                  For NORMAL OR "FLU ONSN" products without contract: show not on contract message -->
                <div class="col-sm" *ngIf="isGovtCustomer && 
                                          isGovtLocationSelected &&  
                                          !productDetails?.priceInfos?.conditions &&
                                          showCTA() &&
                                          (!productDetails?.flu ||
                                          (productDetails?.flu && productDetails?.shipNow.toLowerCase() == 'on'))
                                          ;else normalUserFlow">
                  <div class="row prod-no-contract">Product not on<br /> contract</div>
                </div>
                <ng-template #normalUserFlow>
                  <div [ngClass]="{'col-md-6':buttonName!=='Reserve'}">
                    <ng-container *ngIf="showCTA()">
                      <!-- popover content  -->
                      <ng-template #popTitleSuccess>
                        <div class="cart-value-added">
                          <img src="../../../assets/icons/confirmation-positive-green.png" class="positive-green-icon"
                            alt="success" />
                          <span class="confirmation-itemsadded">
                            {{ itemAddedQuantity }} units have been added to your
                            cart
                          </span>
                        </div>
                      </ng-template>
                      <!-- ------------------->
                      <button type="button" class="btn-primary" [ngClass]="cssClassForButton()"
                        [ngStyle]="{ float: userDetails  && isVariantSelected ? 'right' : 'left' }"
                        data-di-id="di-id-2fea5a72-b2e23002" [ngbPopover]="popTitleSuccess" placement="bottom"
                        triggers="manual" #p2="ngbPopover" placement="bottom" popoverClass="pdp-itemsuccess-msg"
                        (click)="multiFnBtn(p2,false)">
                        {{ buttonName }}
                      </button>
                    </ng-container>

                    <!-- For non-formulary product  -->
                    <div class="formulary-section" *ngIf="
                      userDetails &&
                      isVariantSelected &&   
                      isFormularyCustomer &&
                      !productDetails?.formularyProduct
                    ">
                      <div>
                        <span>This product is not in your formulary.</span>
                      </div>
                      <div>
                        <a [ngbPopover]="popSaveContent" placement="top" #s3="ngbPopover" triggers="manual"
                          popoverClass="savedordermini-popover" (click)="openPopup(s3)">View details</a>
                      </div>
                      <ng-template #popSaveContent>
                        <div class="mb-3">
                          {{ "plp.viewDetails" | cxTranslate }}
                        </div>
                        <a (click)="navigateFormulary()">{{
                          "plp.viewCurrent" | cxTranslate
                          }}</a>
                        <div class="mt-2 mb-3">
                          {{ "plp.contactInfo" | cxTranslate }}
                        </div>
                      </ng-template>
                    </div>

                    <div *ngIf=" 
                    userDetails &&
                    isVariantSelected &&   
                    (isFormularyCustomer ? productDetails.formularyProduct : true) &&
                    (productDetails?.yellowFever && !isYFauthorized)
                    " class="col-sm-5 p-0" [ngStyle]="{'font-size': '14px'}">
                      <span>Our records indicate that you are not authorized by your State Health Department to purchase
                        Yellow Fever vaccine. To purchase Yellow Fever vaccine, your practice must be certified by your
                        State Health Department, and Sanofi Pasteur must receive proof of this certification directly
                        from the issuing State Health Department. Please call Customer Service at {{ baseSiteId == 'vsh'
                        ? '1-800-VACCINE (1-800-822-2463)' : '1-800-752-9338'}} to obtain contact information for the
                        appropriate party at your State Health Department who can assist you with this process.</span>
                    </div>
                    <!-- ------------- -  -->
                    <!-- Restriction Errors -->
                    <div *ngIf="
                      userDetails &&
                      isLocationSelected &&
                      isVariantSelected &&
                      !prodAvailableForOrder(productDetails) &&
                      (isFormularyCustomer ? productDetails.formularyProduct : true) &&
                      (productDetails?.yellowFever ? isYFauthorized : true)
                    ">
                      <ng-container *ngFor="let item of errorMessages(productDetails)">
                        <p [ngStyle]="{ color: '#CA0000', 'font-size.px': '14' }" [innerHTML]="item">
                        </p>
                      </ng-container>
                    </div>
                    <!-- --------------- -->
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <br />
          <div class="allocation-info" *ngIf="
              productDetails.allocationInfos &&
              prodAvailableForOrder(productDetails) &&
              (isFormularyCustomer ? productDetails.formularyProduct : true) &&
              (productDetails?.yellowFever ? isYFauthorized : true)
            ">
            <p>This product has quantity limits</p>
            <p (click)="openLimitationModal()">View Details</p>
          </div>

          <!-- <section class="sap-allocation-area"
                            *ngIf="!productDetails?.discontinued && productDetails?.available">
                            <section *ngIf="productDetails?.sapAllocation === true">
                                <b class="prod-allocation">{{'plp.productAllocation'|cxTranslate}}</b>
                                <p class="allocation-p">{{'plp.allocationDetails' | cxTranslate}}
                            </section>
                        </section> -->

          <!-- <section class="flu-class"
                            *ngIf="productDetails.flu && productDetails?.available && !productDetails?.discontinued">
                            <section>
                                <p class="contact-info">
                                    {{'plp.productAllocationInfo1'|cxTranslate}}<b>
                                        {{'plp.emergencycontact'|cxTranslate}}</b>{{'plp.productAllocationInfo2'|cxTranslate}}
                                </p>
                            </section>
                           
                        </section> -->
        </section>
        <!-- The End -->
        <section aria-description="Section for additional Volume groups and Storage related infos">
          <section *ngIf="userDetails">
            <section *ngIf="
                (!productDetails?.discontinued && productDetails?.available) ||
                true
              " class="products-accordion clear-fix pt2">
              <section class="panel-group">
                <section class="panel panel-default" *ngIf="productDetails?.priceInfos?.volumePricesFlag">
                  <section class="panel-heading panel-endborder">
                    <section class="first-level-acc">
                      <label><img [src]="'../../assets/icons/'+baseSiteId+'/volume.svg'" class="accordion-img" alt="" />
                        {{ "plp.volumePricing" | cxTranslate }}</label>
                      <span data-toggle="collapse" data-parent="#accordion" href="#pdp-list1" class="acc-plus-icon fa"
                        aria-expanded="panelVolumeExpanded" (click)="panelVolumeExpanded = !panelVolumeExpanded"
                        [ngClass]="
                          panelVolumeExpanded ? 'fa-minus' : 'fa-plus collapsed'
                        "></span>
                    </section>
                  </section>
                  <section id="pdp-list1" class="panel-collapse collapse" aria-expanded="panelVolumeExpanded"
                    (click)="panelVolumeExpanded = !panelVolumeExpanded" [ngClass]="panelVolumeExpanded ? 'in' : ''">
                    <h3>Volume discounts will be calculated in checkout</h3>
                    <section class="panel-body">
                      <section class="discount-list" id="vol-price-pdp">
                        <table aria-describedby="pdpTable">
                          <thead>
                            <th id=""></th>
                          </thead>
                          <tbody *ngFor="
                              let prices of productDetails?.priceInfos
                                ?.volumePrices as volumePrices;
                              let i = index;let last = last
                            ">
                            <tr>
                              <td>
                                {{ prices?.minQuantity }} <span *ngIf="!last">-</span><span *ngIf="last">+</span>
                                {{ prices?.maxQuantity }}
                                {{ "plp.units" | cxTranslate }}:
                              </td>
                              <td>{{ prices?.value | currency }}</td>
                              <td>
                                <span *ngIf="i > 0">{{ "plp.save" | cxTranslate }}
                                  {{
                                  volumePrices[0].value -
                                  volumePrices[i].value | currency
                                  }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </section>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>
          <section class="products-accordion clear-fix">
            <section class="panel-group">
              <!-- update2 -->
              <section class="panel panel-default" *ngIf="productDetails?.storageDescription">
                <section class="panel-heading">
                  <section class="first-level-acc">
                    <label><img [src]="'../../assets/icons/'+baseSiteId+'/storage.png'" class="accordion-img" alt=" " />
                      {{ "plp.storageinfo" | cxTranslate }}
                    </label>
                    <span data-toggle="collapse " data-parent="#accordion " href="#pdp-list3 " class="acc-plus-icon fa"
                      aria-expanded="panelProductExpanded " (click)="panelProductExpanded = !panelProductExpanded"
                      [ngClass]="
                        panelProductExpanded ? 'fa-minus' : 'fa-plus collapsed'
                      "></span>
                  </section>
                </section>
                <section id="pdp-list3 " class="panel-collapse collapse" aria-expanded="panelProductExpanded "
                  (click)="panelProductExpanded = !panelProductExpanded" [ngClass]="panelProductExpanded ? 'in' : ''">
                  <section class="panel-body productupdate-p" [innerHTML]="productDetails?.storageDescription">
                  </section>
                </section>
              </section>
              <section class="panel panel-default" *ngIf="productDetails.calculator">
                <section class="panel-heading">
                  <section class="first-level-acc">
                    <label><img [src]="'../../assets/icons/'+baseSiteId+'/calculator-plum.svg'" class="accordion-img"
                        alt=" " />
                      {{ "plp.calcinfo" | cxTranslate }}
                    </label>
                    <span data-toggle="collapse " data-parent="#accordion" href="#pdp-list5" class="acc-plus-icon fa"
                      aria-expanded="panelProductExpanded2 " (click)="panelProductExpanded2 = !panelProductExpanded2"
                      [ngClass]="
                        panelProductExpanded2 ? 'fa-minus' : 'fa-plus collapsed'
                      "></span>
                  </section>
                </section>
                <section id="pdp-list5" class="panel-collapse collapse" aria-expanded="panelProductExpanded2 "
                  [ngClass]="panelProductExpanded2 ? 'in' : ''">
                  <section class="panel-body productupdate-p">
                    {{ "plp.calculatorLabel" | cxTranslate }}
                  </section>
                  <section class="panel-body productupdate-p">
                    <div class="row">
                      <div class="col-md-3 calcInput-div">
                        <input #userinput type="text" [(ngModel)]="searchValue" required class="calcInput"
                          name="volumeinLbs" />&nbsp;
                      </div>
                      <div class="col-md-3 reviewvalidbtn-div">
                        <button type="submit" class="btn-primary reviewvalidbtn" data-di-id="di-id-7a6cb2cd-cb37948a"
                          (click)="calculateUnit(userinput)">
                          {{ "plp.calcBtn" | cxTranslate }}
                        </button>
                      </div>
                      <div class="col-md-6">
                        <div id="validdiv" class="col-xs-6 col-md-6 col-sm-6 calc-result"
                          *ngIf="isClicked && isValidInput">
                          <div class="prod-calcresult">
                            {{ calculatedValue }} mLs
                          </div>
                        </div>
                        <div id="invaliddiv" class="col-xs-6 col-md-6 col-sm-6 calc-result"
                          *ngIf="isClicked && !isValidInput">
                          <div class="prod-invalidvalue">
                            {{ "plp.invalidMessage" | cxTranslate }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section class="panel-body productupdate-p">
                    <span *ngIf="baseSiteId == 'vsh'"> {{ "plp.needAssistance" | cxTranslate }}</span>
                    <span *ngIf="baseSiteId == 'vax'"> {{ "plp.vaxServeNeedAssistance" | cxTranslate }}</span>
                  </section>
                </section>
              </section>
              <section class="panel panel-default"
                *ngIf="productDetails?.innerText && productDetails?.innerText !== '' && userDetails">
                <section class="panel-heading">
                  <section class="first-level-acc">
                    <label><img [src]="'../../assets/icons/'+baseSiteId+'/warning_red_new.png'" class="accordion-img"
                        alt=" " />
                      Important notices
                    </label>
                    <span data-toggle="collapse " data-parent="#accordion " href="#pdp-list2" class="acc-plus-icon fa"
                      aria-expanded="panelProductExpanded3" (click)="panelProductExpanded3 = !panelProductExpanded3"
                      [ngClass]="
                        panelProductExpanded3 ? 'fa-minus' : 'fa-plus collapsed'
                      "></span>
                  </section>
                </section>
                <section id="pdp-list2" class="panel-collapse collapse" aria-expanded="panelProductExpanded3"
                  (click)="panelProductExpanded3 = !panelProductExpanded3"
                  [ngClass]="panelProductExpanded3 ? 'in' : ''">
                  <section class="panel-body productupdate-p">
                    <p class="inner-text">
                      <span [innerHtml]="productDetails?.innerText"></span>
                    </p>
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
      </section>
      <!--Related products-->
      <section class="related-product" *ngIf="relatedProducts.length>0">
        <div class="row mb-2 transform-style">
          <div class="col-md-8 col-sm-8 col-xs-12 product-title">
            <p>Related Products</p>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-12" *ngIf="relatedProducts.length>2">
            <ul class="slick-dots">
              <li [ngClass]="{'slick-active':curPage==1}"></li>
              <li [ngClass]="{'slick-active':curPage==2}"></li>
              <li [ngClass]="{'slick-active':curPage==3}" *ngIf="relatedProducts.length>4"></li>
            </ul>
          </div>
        </div>
        <hr>
        <div class="d-flex rel-pdct-cont">
          <div class="pagination pag-mob align-items-center mb-4" *ngIf="relatedProducts.length>2">
            <button class="pagination-btns" (click)="getCurrentPage('prev')">
              <span class="chevronIconWhite prev"></span>
            </button>
            <button class="pagination-btns" (click)="getCurrentPage('next')">
              <span class="chevronIconWhite next"></span>
            </button>
          </div>
          <div class="pagination pag-desk align-items-center" *ngIf="relatedProducts.length>2">
            <button class="pagination-btns" (click)="getCurrentPage('prev')">
              <span class="chevronIconWhite prev"></span>
            </button>
          </div>
          <div *ngFor="let item of tempRelatedProducts" class="mini-card">
            <section class="custom-card-header">
              <a href="javascript:void(0);" (click)="navigatePDP(item.code,item)">
                <img class="image-align" [src]="getImage(item)">
              </a>
              <div class="product-name">
                <a (click)="navigatePDP(item.code,item)" href="javascript:void(0)">
                  <h6 [innerHTML]="item.baseProductName"></h6>
                </a>
              </div>
              <div class="product-description mt-3">
                <a (click)="navigatePDP(item.code,item)" href="javascript:void(0)">
                  <h6 [innerHTML]="item.baseProductDescription"></h6>
                </a>
              </div>
              <div class="product-description">
                <div class="presentation-desc">
                  {{item.description}}
                </div>
              </div>
              <div class="d-flex product-code mt-3">
                <span>{{item.code}}</span><span class="ml-1 mr-1">|</span><span>{{item.manufacturer}}</span>
              </div>
            </section>
            <hr>
            <section class="custom-card-body mb-5">
              <section class="price-section" *ngIf="userDetails">
                <!-- contract groups row -->
                <ng-container>
                  <div class="row flex-column p-3" *ngIf="item.priceInfos?.conditions &&
        item?.priceInfos?.conditions as contractGroups
    ">
                    <p class="custom-tab-title">Contract Group</p>
                    <ng-select *ngIf="contractGroups.length > 1; else singleContract" [items]="contractGroups"
                      [searchable]="false" [clearable]="false" bindLabel="contractDesc" bindValue="contractId"
                      placeholder="Select Contract Group" class="dropdown-contractGroup"
                      (change)="realtedProdContractGroup = $event"></ng-select>
                    <ng-template #singleContract>
                      <p [ngStyle]="{
            'font-size.px': '14',
            color: '#313131',
            'text-transform': 'uppercase'
          }">
                        {{ contractGroups[0].contractDesc }}
                      </p>
                    </ng-template>
                  </div>
                </ng-container>
                <div class="row price-text-style">
                  <div class="col-md-5">
                    <div>Your Price</div>
                    <div>{{getRelatedPrice(item)}}</div>
                    <br />
                    <p *ngIf="item.priceInfos?.conditions?.length > 1 &&  !realtedProdContractGroup">
                      Select contract group to see price.
                    </p>

                    <span class="fedExciseTax" *ngIf="item.priceInfos?.fexciseTax">
                      {{ item?.priceInfos?.fexciseTax?.value ? item?.priceInfos?.fexciseTax?.formattedValue :
                      '$--'}}/package Federal Excise Tax will be
                      added
                    </span>
                  </div>
                  <!-- <div> -->
                  <div class="units mb-3">
                    <span class="unit-style">{{'Units'}}</span>
                    <section class="unit-area">
                      <span class="disabled pointer-style" aria-hidden="true" id="{{'minusIcon'+item?.code}}">
                        <img src="../../assets/icons/less_new.svg" id="{{'unitMinus'+item?.code}}" class="disabled-img"
                          alt="" (click)="performUnitQuantityComputation(2,item?.code,item?.quantityPerUnit,item.uom)">
                        <img src="../../assets/icons/less-disable_new.svg" id="{{'unitMinusDisable'+item?.code}}" alt=""
                          class="disablemore">
                      </span>
                      <input type="number" class="prod-quantity text-center" [value]="1" (keyup)="performUnitQuantityComputation(null,item?.code,
              item?.quantityPerUnit,item.uom)" id="{{'prodQuantity'+item?.code}}" maxlength="4" />
                      <span class="pointer-style" aria-hidden="true" id="{{'plusIcon'+item?.code}}">
                        <img src="../../assets/icons/more.svg" id="{{'unitPlus'+item?.code}}" alt=""
                          (click)="performUnitQuantityComputation(1,item?.code,item?.quantityPerUnit,item.uom)">
                        <img class="disabled-img" src="../../assets/icons/more-disable.svg"
                          id="{{'unitPlusDisable'+item?.code}}" alt="">
                      </span>
                      <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
                        {{'0'}} {{item.uom}}</section>
                    </section>
                  </div>
                  <!-- </div> -->
                </div>
                <ng-container *ngIf="!item?.unavailable; else notAvailable">
                  <p class="err-text" *ngIf="!item?.orderable">
                    {{ item.callNote || 'This product is currently unorderable'}}
                  </p>
                  <p class="err-text" *ngIf="!item.available">
                    This product is temporarily out of stock
                  </p>
                  <p class="err-text" *ngIf="item?.discontinued">
                    <span *ngIf="item?.discontinuedText != null && item?.discontinuedText != ''; else elseBlockMsg"
                      [innerHTML]="item?.discontinuedText"></span>
                    <ng-template #elseBlockMsg>
                      This product has been discontinued
                    </ng-template>
                  </p>
                  <div class="reserve-info" *ngIf="
              buttonName == 'Reserve' &&
               !item?.discontinued &&
                  item?.available &&
                  item?.orderable">
                    <p *ngIf="baseSiteId == 'vsh'">
                      For assistance with your reservation, call 1-800-VACCINE
                      (1-800-822-2463) or contact your Sanofi Pasteur vaccine
                      specialist.
                    </p>
                    <p *ngIf="baseSiteId == 'vax'">
                      For assistance with your reservation, call 1-800-752-9338 or contact your Sanofi Pasteur vaccine
                      specialist.
                    </p>
                  </div>
                </ng-container>
                <ng-template #notAvailable>
                  <p class="err-text">This product is currently unavailable</p>
                </ng-template>
              </section>
            </section>
            <!--if GovtCustomer and isGovtLocationSelected:
            For NORMAL OR "FLU ONSN" products without contract: show not on contract message -->
            <section *ngIf="isGovtCustomer && 
            isGovtLocationSelected &&  
            !item?.priceInfos?.conditions &&
            userDetails &&
            checkMultiFunctionCTA(item) &&
            (!item?.flu ||
            (item?.flu && item?.shipNow.toLowerCase() == 'on'))
            ;else normalUserRelatedProductsFlow">
              <div class="err-text">Product not on contract</div>
            </section>
            <ng-template #normalUserRelatedProductsFlow>
              <section class="button-style col">
                <button *ngIf="userDetails ? checkMultiFunctionCTA(item) : true"
                  [class.locBtnStyles]="buttonName == 'Select a location to order'"
                  [class.showCalender]="relatedButtonName == 'Reserve'" [ngbPopover]="popTitleSuccess"
                  [ngClass]="cssClassForRelatedProdBtn(item)" placement="bottom" #p2="ngbPopover"
                  popoverClass="savesuccess-msg addToCart" container="body" triggers="manual" class="btn-primary"
                  (click)="multiFnBtn(p2,true,item?.code,item)">
                  {{ buttonName }}
                </button>
                <ng-template #popTitleSuccess>
                  <div class="cart-value-added">
                    <img src="../../../assets/icons/confirmation-positive-green.png" class="positive-green-icon"
                      alt="success" />
                    <span class="confirmation-itemsadded">
                      {{ itemAddedQuantity }} units have been added to your cart
                    </span>
                  </div>
                </ng-template>
              </section>
            </ng-template>
          </div>
          <div class="pagination pag-desk align-items-center mb-4" *ngIf="relatedProducts.length>2">
            <button class="pagination-btns" (click)="getCurrentPage('next')">
              <span class="chevronIconWhite next"></span>
            </button>
          </div>
        </div>
      </section>
      <!-- ------------------------------  -->
      <section *ngIf="loggedInDevice == 'mobile'">
        <p class="pdfs-title">
          DOCUMENTS
        </p>
        <section class="prod-detail-pdfs" *ngFor="let doc of monograph">
          <p class="pdfs-list">
            <img class="pdf-icon" [src]="'../../assets/icons/'+baseSiteId+'/pdf.svg'" alt=" " />
            <a alt="link" (click)="openInNewTab(doc.url)" target=" _blank " class="file-link blue">{{
              doc?.realFileName }}</a>
          </p>
        </section>
      </section>
      <div class="ml-2"></div>
      <!-- <div class="ml-2" *ngIf="banner?.url && loggedInDevice == 'mobile'">
        <a [href]="banner?.redirection" target="_self">
          <img class="image-set-in-card banner-img" [src]="banner?.url" alt="banner-img" />
        </a>
      </div> -->

    </section>



  </section>
  <div id="futureshipModalPopup" class="modal in modalbg popup-comp items-in-cart" data-backdrop="true" role="dialog"
    style="display: none;" (click)="$event.stopPropagation();closePopup()">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header header-style justify-content-center">
          <div class="mt-2">
            Please Note
          </div>
        </div>
        <div class="modal-body body-multiloc-style">
          <div>This product can be ordered for immediate shipment and has been added to your cart.</div>
          <div>If you plan to schedule these doses as future shipments, you'll need to checkout separately for
            each
            location.
          </div>
          <div>We appologies for any inconvineance
          </div>
        </div>
        <div class="modal-footer footer-style justify-content-center">
          <section class="col-md-12">
            <button type="button" class="btn-secondary w-100" (click)="closeModal()">
              Close
            </button>
          </section>
        </div>
      </div>
    </div>
  </div>
</section>